"use client"

export default function Custom500() {
  return (
    <>
      <section className="error_page u_spc">
        <div className="container">
          <h1>505</h1>
          <h2>505 HTTP Version Not Supported</h2>
          <p>Your browser or client is trying to communicate with the server using a version of HTTP (like HTTP/1.1 or HTTP/2) that the server doesn’t recognize or support.</p>
        </div>
      </section>
    </>
  );
}